/**
 * Constrains content to the site's max width with responsive gutters.
 * Every section uses this, so the horizontal rhythm stays consistent from
 * 360px to a wide desktop.
 */
const Container = ({ children, size = 'default', className = '', as: Tag = 'div' }) => {
  const sizeClass =
    size === 'narrow'
      ? ' container--narrow'
      : size === 'wide'
        ? ' container--wide'
        : '';

  return (
    <Tag className={`container${sizeClass}${className ? ` ${className}` : ''}`}>
      {children}
    </Tag>
  );
};

export default Container;
